import React from 'react'
import { withTranslation } from 'react-i18next'
import { Paper, Tooltip } from '@mui/material'
import 'react-block-ui/style.css'
import Box from '@mui/material/Box'
import _ from 'lodash'
import { authContext } from '../../../contexts/AuthContext'
import SectionTitle from '../../SectionTitle'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import CPButton from '../../Utils/CPButton'
import Checkbox from '@mui/material/Checkbox'
import { getRetainer } from '../../../services/retainers'
import CPSettingsIconButton from '../../Utils/CPSettingsIconButton'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import RetainerPreview from './FeatureSettings/RetainerPreview'
import RetainerSettings from './FeatureSettings/RetainerSettings'
import { apiUrl } from '../../../config/api'

class FeaturesCard extends React.Component {
  // Tarjeta de features opcionales en la config de cada cliente
  constructor() {
    super()

    this.state = {
      features: [{ id: 2, name: 'My Fees', description: '' }],
      assignedFeatures: [],
      retainerSettings: {},
      retainerPreview: {}
    }
  }

  static contextType = authContext

  componentDidMount() {
    this.fetchAssignedFeatures(this.props.client.id)
  }

  fetchAssignedFeatures = (clientId) => {
    let url = apiUrl('ListAssignedFeaturesByClient')
    fetch(`${url}&clientId=${clientId}`)
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          assignedFeatures: _.map(data, 'id')
        })
      })
  }

  toggleAssignFeature = (event, featureId) => {
    let url = apiUrl('ToggleAssignClientFeature')

    let assignedFeatures = this.state.assignedFeatures
    if (event.target.checked) {
      assignedFeatures.push(featureId)
    } else {
      _.remove(assignedFeatures, (fid) => {
        return fid == featureId
      })
    }
    this.setState({
      assignedFeatures: assignedFeatures
    })

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        featureId: featureId,
        clientId: this.props.client.id,
        value: event.target.checked ? 1 : 0
      })
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('Toggle successful')
      })
      .catch((error) => console.log(error))
  }

  openFeatureSettings = async (feature) => {
    if (feature.name === 'My Fees') {
      let data = await getRetainer(this.props.client.id)
      this.setState({
        retainerSettings: {
          hours: data.hours ? data.hours : 0,
          caseId: data.bq_case_id,
          proposalUrl: data.proposal_url
        }
      })
    }
  }

  handleFeatureSettingsClose = () => {
    this.setState({
      retainerSettings: {},
      retainerPreview: {}
    })
  }

  render() {
    const { t } = this.props

    return (
      <Box sx={{ flexGrow: 1, mb: 4, p: 2, maxWidth: 450 }} component={Paper}>
        <SectionTitle>{t('Features')}</SectionTitle>
        <List dense sx={{ maxWidth: 360 }}>
          {this.state.features.map((feature) => (
            <ListItem
              key={feature.id}
              secondaryAction={
                this.state.assignedFeatures.includes(feature.id) && (
                  <CPSettingsIconButton
                    onClick={() => this.openFeatureSettings(feature)}
                  />
                )
              }
              disablePadding
            >
              <ListItemButton>
                <Checkbox
                  edge='start'
                  onChange={(e) => this.toggleAssignFeature(e, feature.id)}
                  checked={this.state.assignedFeatures.includes(feature.id)}
                />
                <ListItemText primary={t(feature.name)} />
                {!_.isEmpty(feature.description) && (
                  <Tooltip title={t(feature.description)}>
                    <InfoOutlinedIcon fontSize='small' />
                  </Tooltip>
                )}
                {feature.name === 'My Fees' &&
                  this.state.assignedFeatures.includes(feature.id) && (
                    <CPButton
                      icon={<SearchOutlinedIcon />}
                      tooltip={t('Preview')}
                      onClick={() =>
                        this.setState({
                          retainerPreview: { clientId: this.props.client.id }
                        })
                      }
                    />
                  )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <RetainerSettings
          settings={this.state.retainerSettings}
          clientId={this.props.client.id}
          handleDialogClose={this.handleFeatureSettingsClose}
        />
        <RetainerPreview
          openPreview={this.state.retainerPreview}
          clientId={this.props.client.id}
          handleDialogClose={this.handleFeatureSettingsClose}
        />
      </Box>
    )
  }
}

export default withTranslation()(FeaturesCard)
